import React from 'react';

const AfterpartyTheme = {
  headerLogo: {
    src: '/themes/theme/afterparty/logo.png',
    alt: 'Afterparty Studios Logo',
    size: 60,
  },
  darkLogo: {
    src: '/themes/theme/afterparty/logo.png',
    alt: 'Afterparty Studios Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="100" src="/themes/theme/afterparty/logo.png" alt="Afterparty Studios Logo" />
      <br /><br />
      <h3>AfterParty Studios Influencer Platform</h3>
    </div>
  ),
  shareSite: 'https://afterpartyr.dyzio.co',
};

export default AfterpartyTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/afterparty.js
 **/